"use client";

import { DockSkeleton } from "./Dock";
import { ChatHomeSkeleton } from "./ChatHome";
export function DesktopShellSkeleton() {
  return <div className="fixed inset-0 overflow-hidden bg-offwhite" aria-busy inert data-sentry-component="DesktopShellSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx">
            <DockSkeleton data-sentry-element="DockSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx" />
            <ChatHomeSkeleton data-sentry-element="ChatHomeSkeleton" data-sentry-source-file="DesktopShellSkeleton.tsx" />
        </div>;
}